<template>
	<div class="makeup" v-if="isShowPage">
		<a class="weui-cell  weui-cell_access weui-cell_example" href="javascript:;">
			<div class="weui-cell__bd">
				<p>申请信息</p>
			</div>
			<div class="weui-cell__ft" @click="openContent">{{switchName}}</div>
		</a>
		<div v-if='isShowMoreFlag'>
			<div></div>
			<div class="weui-cell">
				<div class="weui-cell__bd">
					<div class="name-left">申请编号</div>
				</div>
				<div class="weui-cell__ft" id="requestIdNo">{{requestId}}</div>
			</div>
			<div class="weui-cell">
				<div class="weui-cell__bd">
					<div class="name-left">就医医院</div>
				</div>
				<div class="weui-cell__ft" style="color: #333333" id="hosShortName">{{hosName}}</div>
			</div>
			<div class="weui-cell">
				<div class="weui-cell__bd">
					<div class="name-left">患者姓名</div>
				</div>
				<div class="weui-cell__ft" style="color: #333333" id="patientName">{{patientName}}</div>
			</div>
		</div>
		<div v-if='isShowDesc'>
			<div class="weui-cells__title">问题描述</div>
			<div class='pr_desc'>
				<p>{{problemDesc}}</p>
			</div>
		</div>
		<div class="weui-cells__title" v-if="isShowMakeUp">补录信息</div>
		<div class="weui-cells weui-cells_after-title">

			<div v-if="isShowMrNo">
				<div class="weui-cell weui-cell_input cell_height">
					<div class="weui-cell__hd">
						<div class="weui-label cell_width">{{mrName}}</div>
					</div>
					<div class="weui-cell__bd">
						<input id="js_input" class="weui-input" autofocus type="text" v-model="inputMrNo" @input="mrNoInput(inputMrNo)"
						 :placeholder="placeholderMrNo" maxlength="20" />
					</div>
					<img class="alert-danger" @click="showErrorMsg" v-show="isShowAlert" src="../assets/icon-warn.png" />
					<div class='m-vertical_line'></div>
					<div class='weui-cell__ft'>

						<div class='mrNoOld'>
							<div>{{userMrNo}}</div>
							<div>(上次输入)</div>
						</div>
					</div>

				</div>
				<div class='weui-cell'>
					<div class='eg'>{{mrNoHint}}</div>
				</div>
			</div>


			<div class="weui-cell weui-cell_input cell_height" v-if="isShowInDate">
				<div class="weui-cell__hd">
					<div class="weui-label cell_width">入院时间</div>
				</div>
				<div class="weui-cell__bd" @click="showInDate">
					<input class="weui-input" placeholder-style='font-size:15px;' placeholder='请选择出院时间' :value="inHospitalDate"
					 disabled='true' />
				</div>
				<van-popup v-model="showPicker" position="bottom">
					<van-datetime-picker v-model="currentDate" type="date" :min-date="minDate" :max-date="maxDate" @confirm="onConfirm"
					 @cancel="showPicker = false" />
				</van-popup>
				<div class='m-vertical_line'></div>
				<div class='weui-cell__ft'>

					<div class='mrNoOld'>
						<div>{{oldInDate}}</div>
						<div>(上次输入)</div>
					</div>
				</div>
			</div>

			<div class="weui-cell weui-cell_input" v-if="isShowOutDate">
				<div class="weui-cell__hd">
					<div class="weui-label cell_width">出院时间</div>
				</div>
				<div class="weui-cell__bd" @click="showOutDate">
					<input class="weui-input" placeholder='请选择出院时间' :value="outHospitalDate" disabled='true' />
				</div>
				<van-popup v-model="showPicker2" position="bottom">
					<van-datetime-picker v-model="currentDate2" type="date" :min-date="minDate2" :max-date="maxDate2" @confirm="onConfirm2"
					 @cancel="showPicker2 = false" />
				</van-popup>
				<div class='m-vertical_line'></div>
				<div class='weui-cell__ft'>
					<div class='mrNoOld'>
						<div>{{oldOutDate}}</div>
						<div>(上次输入)</div>
					</div>
				</div>
			</div>

			<div class="weui-cell weui-cell_input" v-if="isShowHosDep">
				<div class="weui-cell__hd">
					<div class="weui-label cell_width">科室-医生</div>
				</div>
				<div class="weui-cell__bd">
					<input class="weui-input" autofocus type="text" v-model="hosDep" placeholder="请输入科室与医生" />
				</div>
				<div class='m-vertical_line'></div>
				<div class='weui-cell__ft'>

					<div class='mrNoOld'>
						<div>{{patientHosDep}}</div>
						<div>(上次输入)</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="picArray!=null&&picArray.length>0">
		<div class="weui-cells__title">证件上传</div>
		<div class="weui_cells weui-cells_form pic_padding-bottom" style="background-color: #fff">

			<div class="weui-row" id="container1" name="img">
				<!--2格图的情况下布局-->
				<div class="pic-ui">
					<div class="pic-col-22" v-for="(item,index) in picArray" :key="'pic'+ index" @click="changeImage(index)">
						<div>
							<div class='img-group'>
								<img :id="'image' + index" class="pic-ui-image" :src='item.paramDesc' />
								<div class='text_say'>
									<text class='text_desc'></text>
								</div>
							</div>
							<div class="text-idcard card_text">{{item.paramDispName}}</div>
						</div>
					</div>

				</div>
			</div>
			<div id="uploader-demo" style="margin-top: 15px;display: none">

				<div id="filePicker"></div>

			</div>
		</div>
		</div>
		<div class='bottom-say'>请按照要求仔细填写信息。如有问题，请在“病案通”公众号进行回复，咨询客服。或拨打电话：
			<a class='phonenum' href="tel:400-136-3666">400-136-3666</a>
		</div>
		<van-button type="primary" size="large" class="btn-next" :disabled="disabledSubmit" safe-area-inset-bottom @click="submit"
		 color="#1aad19">提交</van-button>
	</div>
</template>

<script>
	import WebUploader from 'webuploader'
	import $ from 'jquery'
	import '../styles/webuploader.css'
	import Vue from 'vue';
	import {
		Notify,
		Dialog
	} from 'vant';
	Vue.use(Notify);
	Vue.use(Dialog);
	let mrNoRule;
	let imageType;
	let servicePathArr = [];
	let strPathArr = [];
	let mrNo;
	let hosParams;
	export default {
		data() {
			return {
				isShowMoreFlag: false,
				isShowDesc: true,
				inHospitalDate: '',
				outHospitalDate: '',
				showPicker: false,
				showPicker2: false,
				minDate: new Date(1949, 10, 1),
				maxDate: getCurrenDate(),
				minDate2: new Date(1949, 10, 1),
				maxDate2: addDate(getCurrenDate(), 7),
				currentDate: new Date(),
				currentDate2: new Date(),
				problemDesc: '',
				isShowInDate: false,
				isShowOutDate: false,
				isShowHosDep: false,
				oldInDate: '',
				oldOutDate: '',
				userMrNo: '',
				mrName: '',
				placeholderMrNo: '',
				requestId: '',
				hosName: '',
				patientName: '',
				mrNoHint: '',
				switchName: '查看',
				isShowAlert: false,
				inputMrNo: '',
				picArray: [],
				uploadState: false,
				previewIndex: '0',
				disabledSubmit: false,
				hosDep:'',
				isShowMakeUp:false,
				isShowPage:false,
				isShowMrNo:false
			}
		},
		created() {
			// let requestId = localStorage.getItem('requestId');
			let requestId = this.$route.params.requestId;
			let userId = localStorage.getItem("userId");
			let params = {
				requestId: requestId,
				userId: userId
			}
			this.getMakeUp(params);
		},
		methods: {
			showInDate() {
				this.showPicker = true;
			},
			showOutDate() {
				this.showPicker2 = true;
			},
			onConfirm(date) {
				this.inHospitalDate = this.$util.formatTime1(date);
				this.showPicker = false;
			},
			onConfirm2(date) {
				this.outHospitalDate = this.$util.formatTime1(date);
				this.showPicker2 = false;
			},
			getMakeUp(params) {
				let that = this;
				let wxId = localStorage.getItem('wxId')
				this.$server.getMakeUp(params).then(res => {
					console.log(res)
					if (res.result == 1) {
						that.isShowPage = true;
						mrNo = res.mrNo;
						if(mrNo!=null){
							that.isShowMrNo = true
						}
						hosParams = res.hosParams;
						if(mrNo!=null||(hosParams!=null&&hosParams.length>0)){
							this.isShowMakeUp = true;
						}
						let picArray = res.deaths;
						that.picArray = picArray;
						let userId = res.request.userId;
						let hosId = res.request.hosId;
						that.requestId = res.request.requestId
						if (res.desc != null && res.desc != "" && res.desc != undefined) {
							that.problemDesc = res.desc;
							that.isShowDesc = true;
						} else {
							that.isShowDesc = false;
						}
						for (let i in hosParams) {
							if (hosParams[i] == 'inHosTimes') {
								that.isShowInDate = true;
							} else if (hosParams[i] == 'outHosTimes') {
								that.isShowOutDate = true;
							} else if (hosParams[i] == "patientHosDep") {
								that.isShowHosDep = true;
							}
						}
						let userHosOutDate = res.request.userHosOutDate;
						let userHosInDate = res.request.userHosInDate;
						if (userHosOutDate != null && userHosOutDate != '') {
							that.oldOutDate = that.$util.normalString(userHosOutDate.substr(0, 10))
						}
						if (userHosInDate != null && userHosInDate != '') {
							that.oldInDate = that.$util.normalString(userHosInDate.substr(0, 10))
						}
						that.hosName = that.$util.normalString(res.request.hosShortName);
						that.patientName = that.$util.normalString(res.request.patientName)
						that.userMrNo = that.$util.normalString(res.request.userMrNo);
						that.patientHosDep = that.$util.normalString(res.request.patientHosDep);

						if (mrNo != null) {
							mrNoRule = mrNo.mrNoRule;
							that.mrNoHint = mrNo.mrNoHint;
							that.mrName = that.$util.normalString(mrNo.name);
							that.placeholderMrNo = '请输入' + that.$util.normalString(mrNo.name)
							console.log(mrNoRule)
						}

						setTimeout(function() {
							// 初始化Web Uploader
						let loading; 
							var params = 'userId=' + userId + '&token=' + localStorage.getItem('token');
							var uploader = WebUploader.create({

								// 选完文件后，是否自动上传。
								auto: true,

								// swf文件路径
								swf: '../utils/Uploader.swf',

								// 文件接收服务端。
								server: that.GLOBAL.BASE_URL + 'v1/uploadImage?' + params,

								// 选择文件的按钮。可选。
								// 内部根据当前运行是创建，可能是input元素，也可能是flash.
								pick: {
									id: '#filePicker',
									multiple: false,
								},
								// 可重复上传
								duplicate: true,

								// 只允许选择图片文件
								accept: {
									title: 'Images',
									extensions: 'gif,jpg,jpeg,bmp,png',
									mimeTypes: 'image/*'
								},

								// 配置压缩的图片
								compress: {

									width: 1600,
									height: 1600,

									// 图片质量，只有type为`image/jpeg`的时候才有效。
									quality: 90,

									// 是否允许放大，如果想要生成小图的时候不失真，此选项应该设置为false.
									allowMagnify: false,

									// 是否允许裁剪。
									crop: false,

									// 是否保留头部meta信息。
									preserveHeaders: true,

									// 如果发现压缩后文件大小比原来还大，则使用原来图片
									// 此属性可能会影响图片自动纠正功能
									noCompressIfLarger: false,

									// 单位字节，如果图片大小小于此值，不会采用压缩。
									compressSize: 0
								}
							});
							// // 当有文件添加进来的时候
							// uploader.on('fileQueued', function(file) {
							// 	console.log(file)
							// 	// that.imageArr = 

							// });
							// 文件发送前，是否附加参数。
							uploader.on('uploadBeforeSend', function(obj, data) {
								that.uploadState = true;
								console.log('uploadBeforeSend');
								data.wxId = wxId;
								data.hosId = hosId;
								data.type = 1;
								data.userId = userId;
								data.imageType = imageType;
								data.requestId = that.requestId;
								loading = that.$weui.loading('上传中...', {
									className: 'custom-classname'
								});
							});
							// // 文件上传过程中创建进度条实时显示。
							// uploader.on('uploadProgress', function(file, percentage) {
							// 	var $li = $('#' + file.id),
							// 		$percent = $li.find('.progress span');

							// 	// 避免重复创建
							// 	if (!$percent.length) {
							// 		$percent = $('<p class="progress"><span></span></p>')
							// 			.appendTo($li)
							// 			.find('span');
							// 	}

							// 	$percent.css('width', percentage * 100 + '%');
							// });

							// 文件上传成功，给item添加成功class, 用样式标记上传成功。
							uploader.on('uploadSuccess', function(file, response) {
								that.uploadState = false;
								console.log(response._raw)
								loading.hide();
								uploader.makeThumb(file, function(error, src) {
									that.imageUrl = src;
									if (error) {
										// $img.replaceWith('<span>不能预览</span>');
										return;
									}

									var $imageId = '#image' + that.previewIndex;
									$($imageId).attr('src', src);
									$($imageId).addClass('wyfui-image');

									var width = $($imageId).width();
									var height = width * 0.8;
									$($imageId).css('height', height);

								}, 1000, 1000);
								that.createImageObj(that.picArray[that.previewIndex].paramName, response.files[0], that.picArray[that.previewIndex]
									.paramType);

							})
							// 文件上传失败，显示上传出错。
							uploader.on('uploadError', function() {
								that.uploadState = false;
								Notify({
									type: 'warning',
									message: '上传失败,请稍后重试'
								})
								// var $li = $('#' + file.id),
								// 	$error = $li.find('div.error');

								// // 避免重复创建
								// if (!$error.length) {
								// 	$error = $('<div class="error"></div>').appendTo($li);
								// }

								// $error.text('上传失败');
							});

							// // 完成上传完了，成功或者失败，先删除进度条。
							// uploader.on('uploadComplete', function(file) {
							// 	$('#' + file.id).find('.progress').remove();
							// });
						}, 1000);
					}else if(res.result == 2000){
						this.isShowPage = false;
						Dialog.alert({
							title: '标题',
							message: res.msg
						}).then(() => {
								console.log('点击确认');
								that.$router.replace('/home')
						});
					}
				})
			},
			openContent() {
				if (this.switchName == '查看') {
					this.switchName = '收起';
					this.isShowMoreFlag = true;
				} else {
					this.switchName = '查看';
					this.isShowMoreFlag = false;
				}
			},
			mrNoInput(e) {
				console.log(e)
				isRegValid(this, e, mrNoRule)
			},
			showErrorMsg() {
				Notify({
					type: 'warning',
					message: this.mrNoHint
				})
			},
			/**
			 * 点击上传图片
			 */
			changeImage(index) {
				if (this.uploadState == true) {
					return
				}
				let baseUrl = this.picArray[index].paramDesc;
				let imageId = 'image' + index;
				let that = this;
				this.previewIndex = index;
				imageType = this.picArray[index].paramType;
				if ($('#' + imageId)[0].src == baseUrl) {
					// 添加相机，并主动响应input事件
					$('.webuploader-element-invisible').trigger('click');
				} else {
					// ImagePreview([this.imageUrl]);
					// this.$weui.gallery(this.imageUrl)
					var gallery = that.$weui.gallery(that.imageUrl, {
						className: 'custom-classname',
						onDelete: function() {
							// if(confirm('确定删除该图片？')){ console.log('删除'); }
							that.$weui.dialog({
								title: '确认',
								content: '是否要删除这张照片',
								className: 'custom-classname',
								buttons: [{
									label: '取消',
									type: 'default',
									onClick: function() {
										gallery.hide(function() {
											console.log('`gallery` has been hidden');
										});
									}
								}, {
									label: '确定',
									type: 'primary',
									onClick: function() {
										gallery.hide(function() {
											let imageId = 'image' + index;
											let baseUrl = that.picArray[index].paramDesc;

											$('#' + imageId).attr('src', baseUrl);
											updateServicePathArr(that.picArray[index].paramName);
										});
									}
								}]
							});

						}
					});
				}
			},
			createImageObj(paramName, paramValue, paramType) {

				updateServicePathArr(paramName);

				let status = '2';
				var imageObj = {
					'paramName': paramName,
					'requestId': this.requestId,
					'paramValue': paramValue,
					'status': status,
					'paramType': paramType
				};

				servicePathArr.push(imageObj);
			},
			submit() {
				let jsonArr = '';
				if (servicePathArr.length > 0) {
					jsonArr = JSON.stringify(servicePathArr);
					console.log(jsonArr)
				}
				if (mrNo != null) {
					if (this.$util.isNullString(this.inputMrNo)) {
						Notify({
							type: 'warning',
							message: '请输入' + mrNo.name
						})
						return;
					}
					if (this.isShowAlert) {
						Notify({
							type: 'warning',
							message: mrNo.mrNoHint
						})
						return;
					}
					createObj(this, 'userMrNo', this.inputMrNo, '2');
				}
				if (hosParams != null && hosParams.length > 0) {
					if(this.isShowInDate){
						if (this.inHospitalDate == '') {
							Notify({
								type: 'warning',
								message: '请选择入院时间'
							})
							return
						} else {
							let inDate = this.inHospitalDate.replace(/\//g, "-");
							createObj(this, 'inHosTimes', inDate, '2');
						}
					}
					if(this.isShowOutDate){
						if (this.outHospitalDate == '') {
							Notify({
								type: 'warning',
								message: '请选择出院时间'
							})
							return
						} else {
							let outDate = this.outHospitalDate.replace(/\//g, "-");
							createObj(this, 'outHosTimes',outDate, '2');
						}
					}
					if(this.isShowInDate == true && this.isShowOutDate == true){
						if(this.compareDate(this.inHospitalDate,this.outHospitalDate)){
							Notify({
								type: 'warning',
								message: '入院时间不能大于出院时间'
							})
							return
						}
						
					}
					if(this.isShowHosDep){
						if (this.hosDep == '') {
							Notify({
								type: 'warning',
								message: '请输入科室和医生'
							})
							return
						} else {
							createObj(this, 'patientHosDep', this.hosDep, '2');
						}
					}
					
				}
			

				if (this.picArray.length > 0) {
					let vertifyImageNum = this.picArray.length;

					if (servicePathArr.length < vertifyImageNum) {
						Notify({
							type: 'warning',
							message: '请上传证件照片'
						})
						return;
					}

				}
				let paramJson = '';
				if (strPathArr.length > 0) {
					paramJson = JSON.stringify(strPathArr);
				}
				let params = {
					params: paramJson,
					imageParams: jsonArr,
					requestId: this.requestId
				}
				this.disabledSubmit = true;
				this.creatMarkup(params);
			},
			creatMarkup(params) {
				let that = this;
				this.$server.markup(params).then(res => {
					if (res.result == 1) {
						Dialog.alert({
							title: '标题',
							message: '补录成功'
						}).then(() => {
								console.log('点击确认');
								that.$router.replace('/home')
						});
						that.disabledSubmit = false;
					}else{
						this.disabledSubmit = false;
					}
				})
			},
			compareDate(d1, d2) {
			  return (new Date(d1)) > (new Date(d2))
			}

		}
	}

	function getCurrenDate() {
		var day2 = new Date();
		day2.setTime(day2.getTime());
		// var s2 = day2.getFullYear() + "/" + (day2.getMonth() + 1) + "/" + day2.getDate();

		return day2;
	}

	function addDate(date, days) {
		var d = new Date(date);
		d.setDate(d.getDate() + days);
		// var m = d.getMonth() + 1;
		return d;
	}

	function isRegValid(that, inputValue, tmpRole) {
		var regName = new RegExp(tmpRole);
		if (regName.test(inputValue)) {
			that.isShowAlert = false;
		} else {
			that.isShowAlert = true;
		}
	}

	function updateServicePathArr(paramName) {
		for (var i in servicePathArr) {
			var obj = servicePathArr[i];
			if (obj.paramName == paramName) {
				servicePathArr.splice(i, 1);
				return;
			}
		}
	}

	function createObj(that, paramName, paramValue, status) {

		updateStrPathArr(paramName);
		var strObj = {
			'paramName': paramName,
			'requestId': that.requestId,
			'paramValue': paramValue,
			'status': status,
		};

		strPathArr.push(strObj);
	}

	function updateStrPathArr(paramName) {
		for (var i in strPathArr) {
			var obj = strPathArr[i];
			if (obj.paramName == paramName) {
				strPathArr.splice(i, 1);
				return;
			}
		}
	}
</script>

<style>
	.pr_desc {
		background: white;
		font-size: 15px;
		padding: 15px 15px;
	}

	.alert-danger {
		font-size: 10px;
		color: red;
		width: 20px;
		height: 20px;
	}

	.mrNoOld {
		font-size: 14px;
		color: #ec2828;
		text-align: center;
		padding: 0 5px;
		width: 90px;
	}

	.m-vertical_line {
		margin-left: 5px;
		width: 1px;
		height: 30px;
		background: #eee;
	}

	.name-left {
		color: #888888;
	}

	.pic_padding-bottom {
		padding-bottom: 5px;
	}

	.pic-ui {
		width: 100%;
		/* margin-bottom: 80px; */
	}

	.pic-col-22 {
		width: 100%;
		text-align: center;
		display: inline-block;
	}

	.pic-ui-image {
		width: 90%;
		height: 200px;
		text-align: center;
		margin-top: 10px;
	}

	.bottom-say {
		font-size: 14px;
		color: #bbb;
		padding: 20px 50px;
		padding-bottom: 80px;
		text-align: center;
	}

	.phonenum {
		color: #007de4;
	}
</style>
